import { render, staticRenderFns } from "./MerchantOrders.vue?vue&type=template&id=a84f7530&scoped=true"
import script from "./MerchantOrders.vue?vue&type=script&lang=js"
export * from "./MerchantOrders.vue?vue&type=script&lang=js"
import style0 from "./MerchantOrders.vue?vue&type=style&index=0&id=a84f7530&prod&scoped=true&lang=css"
import style1 from "./MerchantOrders.vue?vue&type=style&index=1&id=a84f7530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84f7530",
  null
  
)

export default component.exports